import { render, staticRenderFns } from "./DadosVeiculo.vue?vue&type=template&id=00a0a9ba"
import script from "./DadosVeiculo.vue?vue&type=script&lang=js"
export * from "./DadosVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports